module.exports = __webpack_public_path__ + "static/media/no_page.17fef350.png";